/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.settings.controllers', [
  'acme.common.service.passes',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])

.controller('PassesCreateSettingsController', ['$scope', 'CalendarService', 'PassesService', function($scope, CalendarService, PassesService) {

    $scope.passesCreateSettings = {

      model: {},
      visitCountType: 'single',
      guestCountType: 'none',
      startDate: new Date(),
      endDate: new Date(),
      visits: 0,
      maxQuantity: 0,
      perpetual: false,

      init: function() {
        this.model = PassesService.attributes.getModel();
        this.restoreDates();
        this.restoreMaxUses();
        this.restoreMaxQuantity();

        $scope.$on('PassesCreateController::UpdateModel', this.onPassesCreateControllerUpdateModel);
        $scope.$on('PassesCreateController::Save', this.onPassesCreateControllerSave);
        $scope.$on('$destroy', this.onDestroy);
      },

      updateMaxUses: function() {
        var uses;

        switch (this.visitCountType) {
          case 'count':
            uses = this.visits;
            break;
          case 'unlimited':
            uses = null;
            break;
          case 'single':
            /* falls through */
          default:
            uses = 1;
            break;
        }

        this.model.maxUses = uses;
      },

      updateMaxQuantity: function() {
        var quantity = 1;

        switch (this.guestCountType) {
          case 'count':
            quantity = this.maxQuantity;
            break;
          case 'none':
            quantity = null;
            break;
          default:
            quantity = 1;
            break;
        }

        this.model.maxQuantity = quantity;
      },

      updateDates: function() {
        var end,
            start = CalendarService.toISO8601(this.startDate).split('T');

        this.model.startDate = start[0] + 'T00:00:00' + start[1].substr(-5);

        if (this.perpetual) {
          this.model.endDate = null;
        }else {
          end = CalendarService.toISO8601(this.endDate).split('T');
          this.model.endDate = end[0] + 'T23:59:59' + end[1].substr(-5);
        }
      },

      restoreDates: function() {
        if (this.model.startDate) {
          this.startDate = CalendarService.parseDate(this.model.startDate);
        }else{
          this.startDate = new Date();
        }

        if (this.model.endDate) {
          this.endDate = CalendarService.parseDate(this.model.endDate);
          this.perpetual = false;
        }else{
          this.endDate = new Date(this.startDate.getFullYear() + 1, this.startDate.getMonth(), this.startDate.getDate());
          this.perpetual = true;
        }

      },

      restoreMaxUses: function() {

        switch (this.model.maxUses) {
          case null:
            this.visitCountType = 'unlimited';
            this.visits = 0;
            break;
          case 1:
            this.visitCountType = 'single';
            this.visits = 0;
            break;
          case 0:
            /* falls through */
          default:
            this.visitCountType = 'count';
            this.visits = this.model.maxUses;
            break;
        }

      },

      restoreMaxQuantity: function() {

        switch (this.model.maxQuantity) {
          case null:
            this.guestCountType = 'none';
            this.maxQuantity = 1;
            break;
          case 0:
            this.guestCountType = 'count';
            this.maxQuantity = 1;
            break;
          default:
            this.guestCountType = 'count';
            this.maxQuantity = this.model.maxQuantity;
            break;
        }

      },

      checkMaxQuantity: function() {
        if (this.maxQuantity <= 0) {
          this.maxQuantity = 1;
        }
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPassesCreateControllerUpdateModel: function(e, data) {
        var self = $scope.passesCreateSettings;

        self.model = PassesService.attributes.getModel();
        self.restoreDates();
        self.restoreMaxUses();
        self.restoreMaxQuantity();
      },

      onPassesCreateControllerSave: function(e, data) {

        var self = $scope.passesCreateSettings;

        self.updateDates();
        self.updateMaxUses();
        self.updateMaxQuantity();

        PassesService.attributes.setModel(self.model);

      },

      onDestroy: function(e, data) {
        var self = $scope.passesCreateSettings;

        self.updateDates();
        self.updateMaxUses();
        self.updateMaxQuantity();

        PassesService.attributes.setModel(self.model);
      }

    };

    $scope.passesCreateSettings.init();

}])
.controller('PassesCreateSettingsDatePickerController', ['$scope', '$timeout', 'UserPreferencesService', function($scope, $timeout, UserPreferencesService) {

  $scope.passesCreateSettingsDatePicker = {

    isOpen: false,

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },
    isPreferenceLoaded: false,
    init: function() {
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        $scope.passesCreateSettingsDatePicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },
    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },
    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      var self = $scope.passesCreateSettingsDatePicker;
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }

  };

  $scope.passesCreateSettingsDatePicker.init();

}]);